import { useMutation, useQueryClient } from "@tanstack/react-query";
import { fetchApiPut } from "../../../utils";
import { TtOrderMetadata, UpsertOrderMetadataRequest } from "./types";

export function useUpsertOrderMetadata() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (data: UpsertOrderMetadataRequest) => {
            const result = await fetchApiPut<{ metadata: TtOrderMetadata }>(
                "/brokerage/tt/events/orders/metadata/upsert",
                data
            );
            return result;
        },
        onSuccess: () => {
            // Invalidate staged events to refresh metadata association status
            queryClient.invalidateQueries({ queryKey: ["risk", "brokerage", "tt", "staged"] });
            // Also invalidate snapshots in case they need refresh
            queryClient.invalidateQueries({ queryKey: ["risk", "brokerage", "tt", "snapshots"] });
        },
    });
}
